import React, { useId, useState } from 'react';
import PedidosExclusaoConta from './PedidosExclusaoConta';

const normalizarPerfil = (perfil) => String(perfil || '').trim().toLowerCase();

const obterClasseChip = (perfil) => {
  const perfilNormalizado = normalizarPerfil(perfil);

  if (perfilNormalizado === 'admin' || perfilNormalizado === 'administrador') {
    return 'admin-chip admin-chip--admin';
  }

  if (perfilNormalizado === 'moderador') {
    return 'admin-chip admin-chip--moderador';
  }

  if (perfilNormalizado === 'tecnico') {
    return 'admin-chip admin-chip--tecnico';
  }

  return 'admin-chip admin-chip--lojista';
};

const obterRotuloPerfil = (perfil) => {
  const perfilNormalizado = normalizarPerfil(perfil);

  if (perfilNormalizado === 'admin' || perfilNormalizado === 'administrador') {
    return 'Administrador';
  }

  if (perfilNormalizado === 'moderador') {
    return 'Moderador';
  }

  if (perfilNormalizado === 'tecnico') {
    return 'Técnico';
  }

  if (perfilNormalizado === 'lojista') {
    return 'Lojista';
  }

  return String(perfil || 'Perfil').trim() || 'Perfil';
};

function AbaAprovacoes({
  usuariosPendentes,
  aprovarPerfil,
  recusarPerfil,
  somenteConsulta = false,
  gerenciarExclusao,
  podeExcluirConta = false,
  aguardandoReautenticacao = false,
}) {
  const [aba, setAba] = useState('perfis');
  const [exclusaoOcupada, setExclusaoOcupada] = useState(false);
  const id = useId();
  const totalSolicitacoes = usuariosPendentes.reduce(
    (total, user) => total + (user.perfis_solicitados?.length || 0),
    0,
  );
  const solicitacoes = usuariosPendentes.flatMap((user) =>
    (user.perfis_solicitados || []).map((perfil) => ({
      user,
      perfil,
    })),
  );

  return (
    <div className="routine-panel routine-panel--compact">
      <div className="configuracoes-tabs" role="tablist" aria-label="Tipos de aprovação">
        {[['perfis', 'Solicitações de perfil'], ['exclusao', 'Exclusão de conta']].map(([key, label]) => <button key={key} id={`${id}-${key}-tab`} type="button" role="tab" aria-controls={`${id}-${key}-panel`} aria-selected={aba === key} className={`routine-btn ${aba === key ? 'routine-btn--primary' : 'routine-btn--soft'}`} disabled={exclusaoOcupada} onClick={() => setAba(key)}>{label}</button>)}
      </div>
      <div id={`${id}-exclusao-panel`} role="tabpanel" aria-labelledby={`${id}-exclusao-tab`} hidden={aba !== 'exclusao'}>
        <PedidosExclusaoConta gerenciar={gerenciarExclusao} somenteConsulta={!podeExcluirConta} aguardandoReautenticacao={aguardandoReautenticacao} onBusyChange={setExclusaoOcupada} />
      </div>
      <div id={`${id}-perfis-panel`} role="tabpanel" aria-labelledby={`${id}-perfis-tab`} hidden={aba !== 'perfis'}>
      <div className="approvals-panel__header">
        <div className="approvals-panel__stats">
          <span className="approvals-panel__pill">
            {usuariosPendentes.length} conta{usuariosPendentes.length === 1 ? '' : 's'}
          </span>
          <span className="approvals-panel__pill approvals-panel__pill--soft">
            {totalSolicitacoes} pedido{totalSolicitacoes === 1 ? '' : 's'}
          </span>
        </div>
      </div>

      {somenteConsulta && (
        <div className="routine-callout routine-callout--warm" style={{ marginBottom: '16px' }}>
          <p className="routine-callout__text">
            Perfil técnico em modo somente consulta. As aprovações podem ser analisadas, mas não podem ser processadas.
          </p>
        </div>
      )}

      {solicitacoes.length === 0 ? (
        <div className="routine-empty">
          Nenhum pedido pendente no momento.
        </div>
      ) : (
        <div className="routine-table-wrap">
          <table className="routine-table">
            <thead>
              <tr>
                <th>Conta</th>
                <th>Perfil solicitado</th>
                <th style={{ textAlign: 'center' }}>{somenteConsulta ? 'Situação' : 'Ações'}</th>
              </tr>
            </thead>
            <tbody>
              {solicitacoes.map(({ user, perfil }) => (
                <tr key={`${user.id}-${perfil}`}>
                  <td>
                    <div className="admin-user-card">
                      <strong className="admin-user-card__name">{user.nome}</strong>
                      <span className="admin-user-card__email">{user.email}</span>
                    </div>
                  </td>
                  <td>
                    <div className="approvals-request__meta">
                      <span className={obterClasseChip(perfil)}>
                        {obterRotuloPerfil(perfil)}
                      </span>
                      <p className="approvals-request__text">
                        Solicitação pendente de liberação para esta conta.
                      </p>
                    </div>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {somenteConsulta ? (
                      <span className="routine-status routine-status--warning">Pendente</span>
                    ) : (
                      <div className="admin-actions-row">
                        <button
                          type="button"
                          className="routine-btn routine-btn--primary"
                          onClick={() => aprovarPerfil(user, perfil)}
                        >
                          Aprovar
                        </button>
                        <button
                          type="button"
                          className="routine-btn routine-btn--danger"
                          onClick={() => recusarPerfil(user, perfil)}
                        >
                          Recusar
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      </div>
    </div>
  );
}

export default AbaAprovacoes;
